module.exports = __webpack_public_path__ + "img/poly-9.66dbce0b.png";